import React from "react";
import { useTranslation } from "react-i18next";
import { Card, CardBody } from "../../../shared/components/Card";
import {
  Desc,
  LinkAnchor,
  LinkSpan,
} from "../../../shared/components/form/FormElements";
import { BoldSpan, NormalSpan } from "../index";
import { post } from "../../../api/getUser";

const PaymentMethod = ({
  paymentData,
  //handleChangePlan,
  //updateLabel,
  isEquipment = false,
}) => {
  const { t } = useTranslation("common");

  const updatePayment = async () => {
    const res = await post("subscription", {
      querystring: "create_customer_session",
      update_payment: 1,
    });
    window.location.href = res;
  };

  // Handle case when paymentData is null or undefined
  if (!paymentData && !isEquipment) {
    return (
      <div>
        <h5>{t("payment_method")}</h5>
        <div className="d-flex gap-2 align-items-center">
          <i
            className="fi fi-rr-credit-card"
            style={{
              fontSize: "24px",
              position: "relative",
              top: 5,
            }}
          ></i>
          <div className="d-flex align-items-end">
            <BoldSpan style={{ fontWeight: "500" }}>
              {t("no_payment_method")}
            </BoldSpan>
            <span className="mx-2">|</span>
            <LinkAnchor onClick={updatePayment}>{t("add")}</LinkAnchor>

            {/* <NormalSpan>{t("add_payment_method_to_continue")}</NormalSpan> */}
          </div>
        </div>
        {/* <LinkAnchor onClick={handleChangePlan}>
          {t("add_payment_method")}
        </LinkAnchor> */}
      </div>
    );
  }

  const { type, billing_email, details } = paymentData;

  // Helper function to get payment icon - using generic payment icon for all types
  const getPaymentIcon = () => {
    return "fi fi-rr-credit-card";
  };

  // Helper function to format payment details based on type
  const getPaymentDetails = (paymentType, paymentDetails) => {
    if (!paymentDetails)
      return { primary: t("payment_details_unavailable"), secondary: "" };

    switch (paymentType) {
      case "card":
        const brand = paymentDetails.brand || t("card");
        const last4 = paymentDetails.last4 || "****";
        const expMonth = paymentDetails.exp_month || "**";
        const expYear = paymentDetails.exp_year || "**";
        return {
          primary: `${brand} ${t("ending_in_sm")} ${last4}`,
          secondary: `${t("expiry")} ${expMonth}/${expYear}`,
        };

      case "us_bank_account":
        const bankName = paymentDetails.bank_name || t("bank_account");
        const accountLast4 = paymentDetails.last4 || "****";
        const accountType = paymentDetails.account_type || "";
        return {
          primary: `${bankName} ${t("ending_in_sm")} ${accountLast4}`,
          secondary: accountType ? accountType : "",
        };

      case "sepa_debit":
        const sepaLast4 = paymentDetails.last4 || "****";
        return {
          primary: `SEPA ${t("ending_in_sm")} ${sepaLast4}`,
          secondary: t("sepa_debit_account"),
        };

      case "upi":
        const vpa = paymentDetails.vpa || t("upi_id_unavailable");
        return {
          primary: `UPI: ${vpa}`,
          secondary: t("unified_payments_interface"),
        };

      case "link":
        const email =
          paymentDetails.email || billing_email || t("email_unavailable");
        return {
          primary: `Link: ${email}`,
          secondary: t("stripe_link_payment"),
        };

      case "cashapp":
        const cashtag = paymentDetails.cashtag || t("cash_app_unavailable");
        return {
          primary: `Cash App: ${cashtag}`,
          secondary: t("cash_app_payment"),
        };

      default:
        return {
          primary: t("unknown_payment_method"),
          secondary: "",
        };
    }
  };

  const paymentIcon = getPaymentIcon();
  const { primary, secondary } = getPaymentDetails(type, details);
  const displayEmail = billing_email || details?.email || "";

  return (
    <div className="d-flex flex-column gap-2">
      <h5>{t("payment_method")}</h5>

      <div className="d-flex gap-2 align-items-center">
        <i
          className={paymentIcon}
          style={{
            fontSize: "24px",
            position: "relative",
            top: 5,
            //height: "45px",
          }}
        ></i>
        <div className="d-flex align-items-end">
          <BoldSpan>{primary}</BoldSpan>
          <span className="mx-1">|</span>
          {secondary && <NormalSpan>{secondary}</NormalSpan>}
          <span className="mx-1"> • </span>
          <LinkSpan onClick={updatePayment}>{t("update")}</LinkSpan>
        </div>
      </div>
      {/* {displayEmail && <Desc>{displayEmail}</Desc>} */}
      {/* <LinkAnchor onClick={() => handleChangePlan(1)}>
        {updateLabel || `${t("change_payment_method")}`}
      </LinkAnchor> */}
    </div>
  );
};

export default PaymentMethod;
